import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  CreateMarketingFlowPayload,
  MarketingFlow
} from "../../marketing.types";

export const requestCreateMarketingFlow = async (
  payload: CreateMarketingFlowPayload
): Promise<MarketingFlow> => {
  return await instance.post(ApiRoutesMarketing.Flows, payload);
};
